import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  const forYou = ['Quieres dejar adicciones "en general" y necesitas herramientas transversales.', 'Ya lo intentaste antes y quieres un plan más fuerte, práctico y realista.', 'No tienes apoyo profesional y quieres que este ebook sea tu guía.'];
  const notForYou = ['Buscas promesas tipo "cura garantizada".', 'Estás en un cuadro grave de abstinencia (como alcohol/benzodiacepinas con síntomas severos) y no estás dispuesto/a a pedir ayuda médica.'];
  return <section className="py-24 md:py-32 px-6 bg-white" data-id="element-172">
      <div className="max-w-3xl mx-auto" data-id="element-173">
        <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] text-center mb-14" data-id="element-174">
          Para quién es (y para quién no)
        </h2>

        <div className="space-y-6" data-id="element-175">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#7C8B6F]/5 p-8 md:p-10 rounded-2xl border border-[#7C8B6F]/20" data-id="element-176">
            <h3 className="text-xl md:text-2xl font-serif text-[#5A6650] mb-6 flex items-center gap-3" data-id="element-177">
              <div className="w-8 h-8 rounded-full bg-[#7C8B6F] flex items-center justify-center" data-id="element-178">
                <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-179" />
              </div>
              Es para ti si:
            </h3>
            <ul className="space-y-5" data-id="element-180">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-4 text-[#3D3D3D] text-lg leading-relaxed" data-id="element-181">
                  <span className="w-2 h-2 rounded-full bg-[#7C8B6F] mt-2.5 flex-shrink-0" data-id="element-182" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#FAF8F5] p-8 md:p-10 rounded-2xl border border-[#E5E0D8]" data-id="element-183">
            <h3 className="text-xl md:text-2xl font-serif text-[#7D7A76] mb-6 flex items-center gap-3" data-id="element-184">
              <div className="w-8 h-8 rounded-full bg-[#A5A29E] flex items-center justify-center" data-id="element-185">
                <X className="w-5 h-5 text-white" strokeWidth={3} data-id="element-186" />
              </div>
              No es para ti si:
            </h3>
            <ul className="space-y-5" data-id="element-187">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-4 text-[#5D5A56] text-lg leading-relaxed" data-id="element-188">
                  <span className="w-2 h-2 rounded-full bg-[#A5A29E] mt-2.5 flex-shrink-0" data-id="element-189" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}